import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import ClassificationBannerHeader from '../common/banner/classifactionBannerHeader';
import PageHeader from '../common/banner/pageHeader';
import { useNavigate } from 'react-router-dom';

export default function PTVSDetails() {

  const baseRoute = process.env.REACT_APP_BASE_ROUTE || '/';
  const route1 = baseRoute + 'images/analytics/ptvs-2.png';
  const route2 = baseRoute + 'images/analytics/ptvs-3.png';
  const navigate = useNavigate();

  const handleResponse = (() => {
    navigate('/ptvsThreatResponse')
  });
  
  return (
    <Container sx={{ minWidth:1800, mt: 10, mb: 10 }}>
      <Box sx={{pt: 2}}>
        <ClassificationBannerHeader></ClassificationBannerHeader>
        <PageHeader title="CCG Dashboards"></PageHeader>
      </Box>
      <Typography variant='h4' 
        sx ={{display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              fontSize: '1.35em', 
              marginBottom: '10px'}}>
        PTVS Details
      </Typography>
      <Box
        sx={{          
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column'
        }}
      >
      <img 
          alt="ptvs Info"
          src={route1}
          width="100%"
          height="100%"
          style={{ border: 'none', display: 'flex', objectFit: 'none', marginTop: '-130px', marginBottom: '-180px' }}
      />
      <img 
          alt="ptvs Info 2"
          src={route2}
          width="100%"
          height="100%"
          style={{ border: 'none', display: 'flex', objectFit: 'none', marginBottom: '-120px' }}
      />
      <Button
        onClick={handleResponse}
        sx={{ 
          fontSize: '0.7rem',
          marginLeft: "60px", 
          marginTop: '-65px',
          marginBottom: '70px',
          color: '#FFF', 
          bgcolor: '#606662' , 
          height: '22px', 
          '&:hover': {
              backgroundColor: '#1f1e1d',
          } }}>
        HangZhou XiongMai Technologies Net Surveillance Default Credentials
      </Button>
      </Box>
    </Container>
  );
};
